import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { DataForm } from "pages/dataCollection/_shared/DataForm";
import { getShareNotice, updateShareNotice } from "shared/api/ShareNoticeApi";

function DataEdit() {
  const { dataNoticeId } = useParams();
  const [loadedData, setLoadedData] = useState(null);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const fetched = await getShareNotice(dataNoticeId);
        if (!cancelled) setLoadedData(fetched);
      } catch (error) {
        if (!cancelled) setLoadError("자료 정보를 불러오지 못했습니다.");
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [dataNoticeId]);

  const initialValues = loadedData
    ? {
        title: loadedData.title,
        category: loadedData.category,
        pin: loadedData.pin,
        content: loadedData.content,
        files: loadedData.files,
      }
    : null;

  return (
    <DataForm
      mode="edit"
      groupId={loadedData?.category}
      initialValues={initialValues}
      isLoading={!loadedData && !loadError}
      loadError={loadError}
      onSubmit={(data) => updateShareNotice(loadedData.id, data)}
    />
  );
}

export default DataEdit;
